var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/productDetail'));
    // Customize here
    processInclude(require('./product'));
});
